import { Label } from "@EditArticleContainer/shared/components/EditableTextContainer/types/editableText.types";
import { PartnerAxisLASCContent } from "@EditArticleContainer/shared/types/paragraphContents/contents/partnerAxisLASCContent.types";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

const getPartnerAxis = (paragraph: PartnerAxisLASCContent) =>
  paragraph.text["Partner Axis"];

export const partnerANameText = (paragraph: PartnerAxisLASCContent) =>
  createMultiLineText({
    textList:
      getPartnerAxis(paragraph)["Partner A"]
        .at(0)
        ?.["Partner A Name"].value.map((v) => v.text ?? "") ?? [],
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerANameLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)["Partner A"]
    .at(0)
    ?.["Partner A Name"].value.at(0)?.labels ?? []) as Label[];

export const partnerAResponsibilityText = (
  paragraph: PartnerAxisLASCContent,
) =>
  createMultiLineText({
    textList: getPartnerAxis(paragraph)[
      "Partner A Responsibility & Rights"
    ].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerAResponsibilityLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)[
    "Partner A Responsibility & Rights"
  ].value.at(0)?.labels ?? []) as Label[];

export const partnerBNameText = (paragraph: PartnerAxisLASCContent) =>
  createMultiLineText({
    textList:
      getPartnerAxis(paragraph)["Partner B"]
        .at(0)
        ?.["Partner B Name"].value.map((v) => v.text ?? "") ?? [],
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerBNameLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)["Partner B"]
    .at(0)
    ?.["Partner B Name"].value.at(0)?.labels ?? []) as Label[];

export const partnerBResponsibilityText = (
  paragraph: PartnerAxisLASCContent,
) =>
  createMultiLineText({
    textList: getPartnerAxis(paragraph)[
      "Partner B Responsibility & Rights"
    ].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerBResponsibilityLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)[
    "Partner B Responsibility & Rights"
  ].value.at(0)?.labels ?? []) as Label[];

export const partnerCNameText = (paragraph: PartnerAxisLASCContent) =>
  createMultiLineText({
    textList:
      getPartnerAxis(paragraph)["Partner C"]
        .at(0)
        ?.["Partner C Name"].value.map((v) => v.text ?? "") ?? [],
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerCNameLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)["Partner C"]
    .at(0)
    ?.["Partner C Name"].value.at(0)?.labels ?? []) as Label[];

export const partnerCResponsibilityText = (
  paragraph: PartnerAxisLASCContent,
) =>
  createMultiLineText({
    textList: getPartnerAxis(paragraph)[
      "Partner C Responsibility & Rights"
    ].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const partnerCResponsibilityLabels = (
  paragraph: PartnerAxisLASCContent,
): Label[] =>
  (getPartnerAxis(paragraph)[
    "Partner C Responsibility & Rights"
  ].value.at(0)?.labels ?? []) as Label[];
